import 'moment/locale/es'
import Ul from '../../../../components/Ul'
import DataTable, {
    Caption,
    TBody,
    THead
} from '../../../../components/DataTable'
import Typography from '../../../../components/Typography'
import useGet from '../../../../hooks/useGet'
import { OrderInformation } from '../../../Requisition/types'
import { storagePage } from '../../storage'
import buildNumberFormat from '../../../../utilities/buildNumberFormat'
import {
    getProductManufacturerCode,
    getProductPresentationLabel
} from '../../../../utilities/productDisplay'

export default function ProductInventoryView({ data }: { data: any }) {
    const { data: data_orders } = useGet<OrderInformation[]>(
        `/v5.6/apis/requisition/manage/order?requisition_product_id=${storagePage.requisition_product_id}`,
        []
    )
    const items = []
    data_orders.result.forEach(data_order => {
        if (data_order.reception_products.length === 0) {
            items.push({ ...data_order, reception_code: '-' })
        } else {
            data_order.reception_products.forEach(reception_product => {
                items.push({
                    ...data_order,
                    reception_code: reception_product.reception.code
                })
            })
        }
    })

    return (
        <>
            <Typography type="header-3" className="mb-4">
                Información ERP
            </Typography>
            <Ul className="mb-4">
                <li>
                    Descripción de producto:
                    <b className="ml-2">
                        {
                            data.product_company.product_country.product
                                .description
                        }
                    </b>
                </li>
                <li>
                    Código:
                    <b className="ml-2">
                        {getProductManufacturerCode(
                            data.product_company.product_country.product
                        )}
                    </b>
                </li>
                <li>
                    Grupo de presentación:
                    <b className="ml-2">
                        {getProductPresentationLabel(
                            data.product_company.product_country.product
                        )}
                    </b>
                </li>
            </Ul>
            <Typography type="header-3" className="mb-4">
                Información del catálogo
            </Typography>
            <Ul className="mb-4">
                <li>
                    Proveedor:
                    <b className="ml-2">
                        {data.provider_company.provider.business_name}
                    </b>
                </li>
                <li>
                    Descripción: <b>{data.provider_description}</b>
                </li>
            </Ul>
            <div className="grid grid-cols-2 gap-4">
                <Ul className="mb-4">
                    <li>
                        Código: <b>{data.provider_code}</b>
                    </li>
                </Ul>
                <Ul className="mb-4">
                    <li>
                        Costo en catálogo:{' '}
                        <b>{`${
                            data.company_currency.currency.symbol
                        } ${buildNumberFormat(data.purchase_price)}`}</b>
                    </li>
                </Ul>
            </div>
            <Typography type="header-3" className="mb-4">
                Órdenes de compra relacionadas
            </Typography>
            <DataTable scrollHeight={500}>
                <THead>
                    <tr>
                        <th>Información de inventario</th>
                        <th>Cantidad</th>
                        <th>Estado</th>
                        <th>Recepción de compra</th>
                    </tr>
                </THead>
                <TBody>
                    {items.map(item => (
                        <tr key={item.id}>
                            <td>{item.purchase.code}</td>
                            <td>{item.quantity}</td>
                            <td>{item.purchase.purchase_state.name}</td>
                            <td>{item.reception_code}</td>
                        </tr>
                    ))}
                    {items.length === 0 && (
                        <Caption colSpan={5}>
                            No se encontraron resultados
                        </Caption>
                    )}
                </TBody>
            </DataTable>
        </>
    )
}
